import { render, staticRenderFns } from "./configureWeb.vue?vue&type=template&id=1f1922cc&scoped=true&"
import script from "./configureWeb.vue?vue&type=script&lang=tsx&"
export * from "./configureWeb.vue?vue&type=script&lang=tsx&"
import style0 from "./configureWeb.vue?vue&type=style&index=0&id=1f1922cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f1922cc",
  null
  
)

export default component.exports